exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-color[data-v-18ed940f]{background-color:#fb8c00;color:#fff;font-weight:700}.fs-14[data-v-18ed940f]{font-size:14px}", ""]);

// exports
